import React from 'react';
import { Box, Flex, Image, Text } from '@chakra-ui/react';

export const SmartphoneMockup = ({ symbol, icon }: { symbol: string; icon: string }) => {
	return (
		<Flex position="relative">
			<Image
				src="/assets/form/telephones.png"
				objectFit="cover"
				maxH="470px"
				maxWidth="886px"
			/>
			<Box
				filter="blur(0.3px)"
				position="absolute"
				h="37px"
				w="37px"
				bgPosition="center"
				backgroundColor="black"
				borderRadius="50%"
				top="62.3%"
				left="40.5%"
				backgroundImage={icon}
				backgroundSize="cover"
			/>
			<Flex alignItems="center">
				<Box
					position="absolute"
					bgColor="white"
					h="12px"
					w="50px"
					top="63.5%"
					left="52%"
				>
					<Text
						fontSize="9px"
						mt="1px"
						filter="blur(0.3px)"
						opacity="0.8"
						ml="2px"
						color="black"
						textTransform="uppercase"
					>
						{symbol}
					</Text>
				</Box>
			</Flex>
		</Flex>
	);
};

export default SmartphoneMockup;
